<tool-drawer-container (openFormDialog)="openDialog()" toolHeaderWidthPct="85">
  <cohort-form class="form-slot"></cohort-form>

  <tool-header
    class="tool-header"
    headerTitle="Cohort Profile"
    subtitle="Displays academic attributes for different cohort by student type"
    helpPagePath="cohort-profile-help-guide"
  ></tool-header>

  <cohort-info-content class="main-content"></cohort-info-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool('Cohort Profile')
    "
  ></related-links>
</tool-drawer-container>
